import React from 'react';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import TuneOutlined from '@mui/icons-material/TuneOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '../../../../../components/ui';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';

export default function GroupManagementCallout({ groupCount = 0, onManageGroups }) {
  const { semantic, radiusPx, typographyStyles } = useFeatureTheme();

  if (!onManageGroups || groupCount <= 0) {
    return null;
  }

  const groupLabel = groupCount === 1 ? '1 group in this form' : `${groupCount} groups in this form`;

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: radiusPx.md,
        border: `1px dashed ${semantic.borders.border}`,
        bgcolor: semantic.surfaces.surface,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              mt: 0.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 36,
              height: 36,
              borderRadius: radiusPx.md,
              bgcolor: semantic.interactive.primarySoft,
              color: semantic.interactive.primary,
              flexShrink: 0,
            }}
          >
            <FolderOutlined sx={{ fontSize: 20 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle2" sx={{ lineHeight: 1.35 }}>
              Global group settings
            </Typography>
            <Typography
              variant="body2"
              sx={{
                ...typographyStyles.caption,
                color: semantic.text.secondary,
                mt: 0.5,
                lineHeight: 1.45,
              }}
            >
              Rename or remove groups used across this form. This does not change which group this
              field belongs to.
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: semantic.text.secondary, display: 'block', mt: 0.75 }}
            >
              {groupLabel}
            </Typography>
          </Box>
        </Stack>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onManageGroups}
          icon={<TuneOutlined sx={{ fontSize: 18 }} />}
          sx={{ flexShrink: 0, alignSelf: { xs: 'stretch', sm: 'center' } }}
        >
          Manage groups
        </Button>
      </Stack>
    </Box>
  );
}
